<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/meeting">Meeting</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Aggiorna il meeting
          </li>
        </ol>
      </div>
      <!-- End .container -->
      <LoadedComponent :loading="loading" />
      <div class="checkout" v-if="!loading">
        <div class="container">
          <div class="row pb-4">
            <div class="col-lg-12">
              <h2 class="checkout-title" style="font-size: 3rem">
                Nuovo meeting
              </h2>
              <AlertComponent :alert-type="'success'" :message="successMessage"></AlertComponent>
              <!-- End .checkout-title -->
              <ul class="nav nav-tabs nav-tabs-bg" id="tabs-1" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" id="tab-1-tab" data-toggle="tab" href="#tab-1" role="tab"
                    aria-controls="tab-1" aria-selected="true">Dati del meeting</a>
                </li>
              </ul>

              <div class="tab-content tab-content-border" id="tab-content-1">
                <div class="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="tab-1-tab">
                  <form class="pt-4 pr-4 pl-4" @submit.prevent="update_meeting">
                    <div class="row">
                      <div class="col-md-12">
                        <ul>
                          <li v-for="(errorMessage, key) in errors" :key="key">
                            <div class="alert alert-danger">
                              {{ errorMessage[0] }}
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div class="col-sm-8">
                        <label for="nome_caso">Titolo del meeting *</label>
                        <input type="text" class="form-control" id="nome_caso"
                          placeholder="Scrivi il titolo del meeting" v-model="form.activity.name" />
                      </div>
                      <!-- End .col-sm-6 -->

                      <div class="col-md-4">
                        <label for="select2Multiple">Autore *</label>
                        <select class="js-example-basic-single form-control" name="autore_id" v-model="form.author_id">
                          <option value="0" selected disabled>
                            Seleziona l'autore
                          </option>

                          <option v-for="author in authors" :key="author.id" :value="author.id">
                            {{ author.text }}
                          </option>
                        </select>
                      </div>

                      <div class="col-sm-4" v-if="meeting.notifications?.public == false">
                        <label for="speakers">Partecipanti </label>
                        <Select2 v-model="form.meeting_partecipants" :options="users" :settings="{
                          multiple: true,
                          selectionCssClass: 'w-100',
                        }" :placeholder="'Seleziona gli utenti'"></Select2>
                      </div>

                      <div class="col-sm-4">
                        <div class="icheck-wetasphalt mt-3">
                          <input type="checkbox" v-model="form.register" id="chb1" checked />
                          <label for="chb1">Registrazione Meeting </label>
                        </div>
                      </div>

                      <div class="col-sm-12 mt-2">
                        <label for="descrizione">Descrizione del post </label>
                        <textarea class="form-control" id="descrizione" rows="3" name="descrizione"
                          placeholder="Spiegazione del tuo post" v-model="form.activity.description"></textarea>
                      </div>

                      <div class="col-sm-12 mt-2" v-if="meeting.cover == null">
                        <div class="input-group mb-3">
                          <div class="custom-file">
                            <input type="file" class="custom-file-input" name="link_2" @change="handleFileUpload"
                              id="link_2" aria-describedby="inputGroupFileAddon01"
                              accept="image/jpg,image/png, image/jpeg" />
                            <label class="custom-file-label text-center" for="link_2" id="labelsfiles">{{ nameFiles
                            }}</label>
                          </div>
                        </div>
                      </div>
                      <div v-if="meeting.cover" class="col-md-12">
                        <div>
                          <div class="d-flex justify-content-center">
                            <img :src="meeting.cover.path" :alt="meeting.cover.name" class="img-thumbnail"
                              style="max-width: 300px" />
                          </div>
                        </div>
                        <div>
                          <div class="text-center">
                            <button type="button" class="btn btn-danger btn-sm mt-2" data-toggle="modal"
                              data-target="#confirm-delete-cover">
                              <i class="las la-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row flex-column pb-2 pl-2 pr-2">
                      <div class="flex-row">
                        <button type="submit" class="btn btn-primary float-right">
                          Aggiorna il meeting <i class="las la-save"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="modal fade" tabindex="-1" role="dialog" id="confirm-delete-cover">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Conferma eliminazione</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-delete-news">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <p>Sei sicuro di voler eliminare la copertina?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              Annulla
            </button>
            <button type="button" class="btn btn-outline-danger" @click="deleteElement">
              Elimina
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import httpservices from "@/services/httpservices.js";
import Select2 from "vue3-select2-component";
import router from "@/router";
import AlertComponent from "@/components/AlertComponent.vue";
export default {
  name: "EditMeeting",
  props: ["slug"],
  components: {
    LoadedComponent,
    Select2,
    AlertComponent,
  },
  data() {
    return {
      meeting: {},
      form: {
        activity: {
          name: "",
          description: "",
        },
        register: false,
        partecipants: [],
        author_id: 0,
        loading: true,
      },
      errors: [],
      authors: [],
      users: [],
      attachment: "",
      nameFiles: "Scegli i file (MAX 1 GIGA)",
      selectedFile: null,
      successMessage: "",
    };
  },
  mounted() {
    this.loadMeeting();
  },
  created() { },
  methods: {
    async loadMeeting() {
      await httpauth
        .get("/meetings/show/" + this.slug)
        .then((response) => {
          this.loading = false;
          if (response.data.data)
          {
            this.meeting = response.data.data;
            this.fetchUsers();
            if (
              this.meeting.status == "programming" ||
              this.meeting.status == "progress"
            )
            {
              this.form.activity.name = this.meeting.name;
              this.form.activity.description = this.meeting.description;
              this.form.activity.id = this.meeting.activity_id;
              this.form.id = this.meeting.id;
              this.form.register = this.meeting.register;
              this.form.author_id = this.meeting.author_id;
              return;
            }

            router.push("meeting/registration/" + this.meeting.slug);
          }
          router.push("/meeting");
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async fetchUsers() {
      await httpservices
        .getUsers()
        .then((response) => {
          var users = response.data.data;
          if (this.meeting.notifications.public == false)
          {
            const usersAppoggio = users.map((user) => ({
              id: user.id,
              text: user.full_name,
            }));

            var userPartecipants = this.filterUsersByIds(
              usersAppoggio,
              this.meeting.user_invitations
            );
            if (this.meeting.notifications.user.length > 0)
            {
              userPartecipants = this.filterUsersByIds(
                userPartecipants,
                this.meeting.notifications.user
              );
            }
            this.users = userPartecipants;
          }

          this.authors = users.map((user) => ({
            id: user.id,
            text: user.full_name,
          }));
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    filterUsersByIds(users, excludedUsers) {
      const excludedIds = excludedUsers.map((user) => user.id);
      return users.filter((user) => !excludedIds.includes(user.id));
    },
    async update_meeting() {
      this.loading = true;
      httpauth
        .post("/meetings/update", this.form)
        .then(async (response) => {
          this.loading = false;
          if (this.selectedFile != null)
          {
            await this.upload_attachments(this.form.id);
            this.successMessage = response.data.message;
            return;
          }
          this.successMessage = response.data.message;
        })
        .catch((error) => {
          this.loading = false;
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }

          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
        });
    },
    async upload_attachments(id) {
      await httpservices.uploadCovers(this.selectedFile, id, "meeting")
        .then(() => {
          this.loading = false;
          this.nameFiles = "Scegli i file (MAX 1 GIGA)";
        }).catch((error) => {
          if (error.response.data.message)
          {
            localStorage.setItem(
              "messageErrorMeeting",
              error.response.data.message
            );
          }
        });

    },
    async deleteElement() {
      this.loading = true;
      httpservices
        .deleteAttachment(this.meeting.cover.id)
        .then((response) => {
          this.loading = false;
          this.loadMeeting();
          this.successMessage = response.data.message;
        })
        .catch((error) => {
          this.loading = false;
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    handleFileUpload(event) {
      const maxSize = 1 * 1024 * 1024 * 1024;
      const files = event.target.files[0];
      const totalSize = files.size;
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (totalSize <= maxSize)
      {
        if (
          !allowedTypes.includes(files.type) ||
          !httpservices.checkDicom(files)
        )
        {
          alert("Per favore seleziona un file valido (JPEG/JPG/PNG).");
          this;
          return;
        }
        this.nameFiles = files.name;
        this.selectedFile = files;
      } else
      {
        alert("La dimensione totale dei file supera 1 GB");
      }
    },
  },
};
</script>